"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = Table;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const Translations_1 = require("../../components/Translations/Translations");
const TableHeader_1 = require("../TableHeader/TableHeader");
const TableBody_1 = require("../TableBody/TableBody");
const table_css_1 = require("./table.css");
const TablePagination_1 = require("../TablePagination/TablePagination");
const EmptyTableItem_1 = require("../EmptyTableItem/EmptyTableItem");
function Table({ table, isReady, emptyTableContent, showPagination = true, pageSizeOptions, expandedRowComponent = null, showHeader = true, }) {
    const isEmpty = table.getRowModel().rows.length === 0 && isReady;
    return (react_1.default.createElement(Translations_1.Translations, null,
        react_1.default.createElement("div", { className: table_css_1.tableWrapper },
            react_1.default.createElement("table", null,
                showHeader && (react_1.default.createElement(TableHeader_1.TableHeader, { getHeaderGroups: table.getHeaderGroups, isReady: isReady, tableState: table.getState() })),
                !isEmpty && react_1.default.createElement(TableBody_1.TableBody, { isReady: isReady, table: table, expandedRowComponent: expandedRowComponent })),
            isEmpty && react_1.default.createElement(EmptyTableItem_1.EmptyTableItem, Object.assign({}, emptyTableContent)),
            isReady && showPagination && (react_1.default.createElement(TablePagination_1.TablePagination, { table: table, pageSizeOptions: pageSizeOptions })))));
}
